
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import JumpWarn from '@/views/financial/JumpWarn.vue'
import { ApplicationDto, getApplication } from '@/api/homes'
import { getUserOtherInfoFCD } from '@/api/commonConfig'
import { getAvoidLoginUrl } from "@/api/iousServices";
import { openFDWhitePage } from '@/utils/h5ToApp'
import { getFinanceAuthority, getStatus } from "@/api/iousServices";
@Component({
  name: 'companyServe',
  components: {
    JumpWarn
  }
})
export default class companyServe extends Vue {
  @Getter info: any // 用户信息
  @Getter userId!: string
  @Getter mobile!: string
  @Getter whiteStrips!: number
  @Getter companyId!: string
  @Prop({default:''}) whiteSignTime!:string
  @Prop({default:''}) endSignTime!:string
  @Action setWhiteStrips!: (val: string) => void
  $refs: {
    jumpWarn:JumpWarn
  }
  isShow = true
  allAppList: ApplicationDto[] = []

  created() {
    this.getApplication()
    this.getFinanceAuthority()
  }

  /**
   * 判断权限
   */
  handleRoute(app: ApplicationDto) {
    console.log(app.applicationName)
    const whiteRoutes = ['storeCollectList','information']
    // const whiteRoutes = ['storeCollectList','information', 'companyInfoForm']
    // if (whiteRoutes.includes(app.action)) {
    if (whiteRoutes.includes(app.action) || app.applicationName === '白条还款') {
      this.goApp(app.route, app.applicationName)
    } else {
      this.$action(app.action) && this.goApp(app.route, app.applicationName)
    }
  }

  /**
   * 获取全部应用
   */
  getApplication() {
    let params = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      scope: '1' // 查询来源
    }
    // const arr = [
    //   {
    //     applicationId: '14222831043731259959',
    //     applicationName: '我的商品',
    //     applicationLogo: 'cyosstest/61a478c2d5e8c85fbbf05a72/2024-03-13/我的商品.png',
    //     partnerCompanyId: 'system',
    //     parentId: 'applyClassify001',
    //     route: '/commodity',
    //     custom: 0,
    //     routePc: ''
    //   },
    //   {
    //     applicationId: '14222831043731259960',
    //     applicationName: '发布商品',
    //     applicationLogo: 'cyosstest/61a478c2d5e8c85fbbf05a72/2024-03-13/发布商品.png',
    //     partnerCompanyId: 'system',
    //     parentId: 'applyClassify001',
    //     route: '/addCommodity',
    //     custom: 0,
    //     routePc: ''
    //   },
    //   {
    //     applicationId: '14222831043731259961',
    //     applicationName: '供应商',
    //     applicationLogo: 'cyosstest/61a478c2d5e8c85fbbf05a72/2024-03-13/供应商.png',
    //     partnerCompanyId: 'system',
    //     parentId: 'applyClassify003',
    //     route: '/shop',
    //     custom: 0,
    //     routePc: ''
    //   },
    //   {
    //     applicationId: '14222831043731259962',
    //     applicationName: '销售单',
    //     applicationLogo: 'cyosstest/61a478c2d5e8c85fbbf05a72/2024-03-13/销售单.png',
    //     partnerCompanyId: 'system',
    //     parentId: 'applyClassify002',
    //     route: '/salesOrderList',
    //     custom: 0,
    //     routePc: ''
    //   },
    //   {
    //     applicationId: '14222831043731259963',
    //     applicationName: '采购单',
    //     applicationLogo: 'cyosstest/61a478c2d5e8c85fbbf05a72/2024-03-13/销售单.png',
    //     partnerCompanyId: 'system',
    //     parentId: 'applyClassify002',
    //     route: '/salesOrderList',
    //     custom: 0,
    //     routePc: ''
    //   }
    // ]
    getApplication(params).then((res) => {
      // @ts-ignore
      // this.allAppList = arr
      this.allAppList = res.data.allList
      this.allAppList.map((item) => {
        item = this._handleAction(item)
      })
    })
  }
  /**
   *  应用数据绑定权限
   */
  _handleAction(app: ApplicationDto) {
    app.action = app.route.substring(1, app.route.length)

    return app
  }
  /**
   * 进入应用内部
   * @param link
   */
  goApp(link: string, applicationName: string) {
    console.log('applicationName', applicationName)
    if (applicationName === '白条还款') {
      let haveRight = '0'
      getStatus().then((res) => {
        haveRight = res.data
        if (haveRight === '1') {
          // 1还款入口 2授信入口 3借款入口
          let flag = 1
          let params = {
            companyId: this.companyId,
            webShow: flag
          }
          getAvoidLoginUrl({...params}).then((res) =>{
            const { code, data } = res
            if( code === "000000" ) {
              let encodeUrl = encodeURI(data.responseData.redirectUrl)
              let isQuery = encodeUrl.indexOf('?') > -1
              let url = `${encodeUrl}${isQuery? '&' : '?'}webShow=${flag}&userPhone=${this.mobile}` //+ (flag == '' ? `&companyName=${this.companyName}` : '')
              // openNewPage({url})
              // window.location.href = url
              openFDWhitePage({url})
              console.log('getAvoidLoginUrl=',url);
            }
          })
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '您不存在未结清的白条还款'
          })
          return false
        }
      })
      // 1、请求接口，看是否有还款的，是否允许页面跳转
      // 2、如果允许跳转，则请求免登录接口，获取跳转的url等参数
      // let url = 'http://10.8.24.11:8076/#/home'
      // let encodeUrl = encodeURI(url)
      // openFDWhitePage({url: encodeUrl})
      // return false
    }
    if (applicationName === '金融服务') {
      this.getAuthority()
      return false
    }
    if (link === '/financialServices') {
      this._getInfoFCD()
      return false
    }
    if (link === '/valetOrder') {
      this.$router.push({ path: link, query: { fromPath: '3' } })
      return false
    }
    this.$router.push(link)
  }

  /**
   * 判断用户金融服务授信是否已过期
   */
  _getInfoFCD() {
    getUserOtherInfoFCD({ userId: this.userId }).then((res) => {
      if (res.code === '000000' && res.data.isExpire !== true) {
        //    跳转到金融服务页面
        this.$router.push({
          path: '/financialServices'
        })
      } else {
        // 进入授信流程
        this.$refs.jumpWarn.showModal()
      }
    })
  }

  // 1还款入口 2授信入口 3借款入口
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.info.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({ ...params })
      .then((res) => {
        const { code, data } = res
        if (code === '000000') {
          let encodeUrl = encodeURI(data.responseData.redirectUrl)
          let isQuery = encodeUrl.indexOf('?') > -1
          let url = `${encodeUrl}${
            isQuery ? '&' : '?'
          }webShow=${flag}&userPhone=${this.mobile}` //+ (flag == '' ? `&companyName=${this.companyName}` : '')
          openFDWhitePage({ url })
        }
      })
      .catch((e) => {
        if (e.message !== '取消重复请求') this.$toast('请先绑定版本码')
      })
  }
  getFinanceAuthority() {
    getFinanceAuthority({companyId: this.companyId}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        this.setWhiteStrips(data.whiteStrips)
      }
      console.log('getFinanceAuthority=',res);
    })
  }

  getAuthority() {
    switch (this.whiteStrips) {
      case 2:
        this.$dialog
          .confirm({
            message: '开通金融服务需完成企业认证',
            confirmButtonText: '去认证',
            cancelButtonText: '取消认证'
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite', '1')
            window.localStorage.setItem('isFinance', '1')
            this.$router.push({
              path: '/companyInfoForm',
              query: {
                formPage: 'h5'
              }
            })
          })
          .catch(() => {})
        break
      case 3:
        this.$dialog
          .confirm({
            message:
              '开通金融服务需完成个人身份认证，且身份为持股比例大于5%的股东',
            confirmButtonText: '去认证',
            cancelButtonText: '取消认证'
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite', '1')
            window.localStorage.setItem('isFinance', '1')
            this.$router.push({
              path: '/userInfoForm',
              query: {
                formPage: 'h5'
              }
            })
          })
          .catch(() => {})
        break
      case 5:
        this.$dialog
          .confirm({
            message:
              '当前账号不符合金融服务开通条件，需企业法人或持股比例大于5%股东才可开通，若您身份已变更，可前往身份认证进行修改',
            confirmButtonText: '去认证',
            cancelButtonText: '取消认证'
          })
          .then(() => {
            this.$router.push({
              path: '/userInfoForm',
              query: {
                formPage: 'h5'
              }
            })
          })
          .catch(() => {})
        break
      case 1:
      case 4:
        // 是否签署授权书
        if (
          window.localStorage.getItem('isSign') == '1' &&
          this.whiteSignTime < this.endSignTime
        ) {
          this.fdfreeLogin()
        } else {
          window.localStorage.removeItem('isSign')
          this.$router.push({
            path: '/iousAuthorize',
            query: {
              cykjSource: 'homes'
            }
          })
        }
        break
    }
  }
}
